// Statuts des commandes (match database schema). Le prothésiste peut passer
// n'importe quelle commande sur n'importe lequel de ces statuts.
export const ORDER_STATUS = {
    PENDING: 'pending',
    IN_PROGRESS: 'in_progress',
    SHIPPED: 'shipped',
    INVOICED: 'invoiced',
    PAUSED: 'paused',
    CANCELLED: 'cancelled'
};

// Labels des statuts
export const ORDER_STATUS_LABELS = {
    [ORDER_STATUS.PENDING]: 'En attente d\'acceptation',
    [ORDER_STATUS.IN_PROGRESS]: 'En cours',
    [ORDER_STATUS.SHIPPED]: 'Expédiée',
    [ORDER_STATUS.INVOICED]: 'Facturée',
    [ORDER_STATUS.PAUSED]: 'En pause',
    [ORDER_STATUS.CANCELLED]: 'Annulée'
};

// Couleurs des badges de statut (dark mode)
export const ORDER_STATUS_COLORS = {
    [ORDER_STATUS.PENDING]: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30',
    [ORDER_STATUS.IN_PROGRESS]: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
    [ORDER_STATUS.SHIPPED]: 'bg-purple-500/20 text-purple-400 border-purple-500/30',
    [ORDER_STATUS.INVOICED]: 'bg-green-500/20 text-green-400 border-green-500/30',
    [ORDER_STATUS.PAUSED]: 'bg-gray-500/20 text-gray-300 border-gray-500/30',
    [ORDER_STATUS.CANCELLED]: 'bg-red-500/20 text-red-400 border-red-500/30'
};

// Types de prothèses
export const PROSTHESIS_TYPES = {
    ADJOINTE: 'adjointe',
    CONJOINTE: 'conjointe',
    AUTRE: 'autre'
};

export const PROSTHESIS_TYPE_LABELS = {
    [PROSTHESIS_TYPES.ADJOINTE]: 'Adjointe',
    [PROSTHESIS_TYPES.CONJOINTE]: 'Conjointe',
    [PROSTHESIS_TYPES.AUTRE]: 'Autre'
};

// Sous-types pour prothèse Adjointe
export const ADJOINTE_SUBTYPES = {
    CHASSIS: 'chassis',
    PAC: 'pac',
    PAP: 'pap',
    PEI: 'pei'
};

export const ADJOINTE_SUBTYPE_LABELS = {
    [ADJOINTE_SUBTYPES.CHASSIS]: 'Chassis',
    [ADJOINTE_SUBTYPES.PAC]: 'Prothèse Amovible Complète (PAC)',
    [ADJOINTE_SUBTYPES.PAP]: 'Prothèse Amovible Partielle (PAP)',
    [ADJOINTE_SUBTYPES.PEI]: 'PEI'
};

// Sous-types pour prothèse Conjointe
export const CONJOINTE_SUBTYPES = {
    COURONNE: 'couronne',
    CHAPPE: 'chappe',
    COURONNE_TRANSVISSEE: 'couronne_transvissee',
    CHAPPE_TRANSVISSEE: 'chappe_transvissee',
    TFM: 'tfm',
    ONLAY: 'onlay',
    PILIER_PERSONNALISE: 'pilier_personnalise',
    BARRE_IMPLANTAIRE: 'barre_implantaire'
};

export const CONJOINTE_SUBTYPE_LABELS = {
    [CONJOINTE_SUBTYPES.COURONNE]: 'Couronne',
    [CONJOINTE_SUBTYPES.CHAPPE]: 'Chappe',
    [CONJOINTE_SUBTYPES.COURONNE_TRANSVISSEE]: 'Couronne transvissée',
    [CONJOINTE_SUBTYPES.CHAPPE_TRANSVISSEE]: 'Chappe transvissée',
    [CONJOINTE_SUBTYPES.TFM]: 'TFM',
    [CONJOINTE_SUBTYPES.ONLAY]: 'Onlay',
    [CONJOINTE_SUBTYPES.PILIER_PERSONNALISE]: 'Pilier personnalisé',
    [CONJOINTE_SUBTYPES.BARRE_IMPLANTAIRE]: 'Barre implantaire'
};

// Numéros de dents par quadrant (notation FDI)
export const TOOTH_QUADRANTS = {
    Q1: { label: 'Quadrant 1', teeth: ['18', '17', '16', '15', '14', '13', '12', '11'] },
    Q2: { label: 'Quadrant 2', teeth: ['21', '22', '23', '24', '25', '26', '27', '28'] },
    Q3: { label: 'Quadrant 3', teeth: ['31', '32', '33', '34', '35', '36', '37', '38'] },
    Q4: { label: 'Quadrant 4', teeth: ['48', '47', '46', '45', '44', '43', '42', '41'] }
};

// Options pour modèle numérique
export const DIGITAL_MODEL_OPTIONS = {
    YES: true,
    NO: false
};

export const DIGITAL_MODEL_LABELS = {
    [DIGITAL_MODEL_OPTIONS.YES]: 'Oui',
    [DIGITAL_MODEL_OPTIONS.NO]: 'Non'
};

// Helper pour obtenir le label d'un sous-type en fonction du type
export const getSubtypeLabel = (prosthesisType, subtype) => {
    if (prosthesisType === PROSTHESIS_TYPES.ADJOINTE) {
        return ADJOINTE_SUBTYPE_LABELS[subtype] || subtype;
    }
    if (prosthesisType === PROSTHESIS_TYPES.CONJOINTE) {
        return CONJOINTE_SUBTYPE_LABELS[subtype] || subtype;
    }
    return subtype || '';
};
